import { jsx as _jsx } from "react/jsx-runtime";
import { SecureMaterialViewer } from './SecureMaterialViewer';
export function PdfViewerModal({ materialId, title, onClose }) {
    return _jsx(SecureMaterialViewer, { materialId: materialId, title: title, onClose: onClose });
}
//# sourceMappingURL=PdfViewerModal.js.map